import { siteConfig } from '../data/siteConfig';
import type { InquiryType } from '../types/content';

export interface InquiryPayload {
  name: string;
  email: string;
  organization: string;
  inquiryType: InquiryType;
  message: string;
  privacyAcknowledged: boolean;
}

export type SubmitResult =
  | { status: 'success' }
  | { status: 'not-configured' }
  | { status: 'error'; message: string };

/**
 * Sends an inquiry to the configured endpoint. Only resolves to `success`
 * when the backend responds with a 2xx status.
 */
export async function submitInquiry(payload: InquiryPayload): Promise<SubmitResult> {
  const endpoint = siteConfig.inquiryEndpoint.trim();
  if (!endpoint) return { status: 'not-configured' };

  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...payload, submittedAt: new Date().toISOString() }),
    });
    if (response.ok) return { status: 'success' };
    return {
      status: 'error',
      message: `We couldn't process your inquiry (error ${response.status}). Please try again shortly.`,
    };
  } catch {
    return {
      status: 'error',
      message: 'We couldn’t reach our inquiry service. Check your connection and try again.',
    };
  }
}
